export const Spinner = () => {
  return (
    <div className="relative inline-block h-20 w-20">
      <div className="absolute animate-ripple rounded-full border-4 border-black opacity-100"></div>
      <div className="lds-ripple absolute animate-ripple rounded-full border-4 border-black opacity-100"></div>
    </div>
  )
}
